export default __webpack_public_path__ + "images/6d0ff123ce0109568e1c5af2a0bd6d86.svg";